import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';

function PaperComponent(props) {
    return (
        <Draggable>
            <Paper {...props} />
        </Draggable>
    );
}

class DraggableDialog extends React.Component {
    state = {
        open: false,
    };

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleCancel = () => {
        this.setState({ open: false });
        this.props.onCancel && this.props.onCancel();
    };

    handleConfirm = () => {
        this.setState({ open: false });
        this.props.onConfirm && this.props.onConfirm();
    };

    render() {
        return (
            <div>
                <div onClick={this.handleClickOpen}>
                    {this.props.children}
                </div>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    PaperComponent={PaperComponent}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle id="draggable-dialog-title">{this.props.contentTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {this.props.contentText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCancel} color="primary">
                            {this.props.cancelText}
                        </Button>
                        <Button onClick={this.handleConfirm} color="primary">
                            {this.props.confirmText}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

DraggableDialog.propTypes = {
    contentTitle: PropTypes.string,
    contentText: PropTypes.string,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
};

export default DraggableDialog;
